// src/index.js
import React from 'react';                           // Import React to use JSX
import ReactDOM from 'react-dom/client';             // Import ReactDOM for rendering to the DOM (React 18+)
import App from './App';      
import './assets/css/default.css'
import './assets/css/globals.css'

// Find the root DOM node
const rootElement = document.getElementById('root');

// Create a root using ReactDOM (React 18+)
const root = ReactDOM.createRoot(rootElement);

// Render the App component inside the root element
root.render(
  <React.StrictMode>                               
    <App />                              
  </React.StrictMode>
);